import { createFileRoute } from '@tanstack/react-router';
import HomePage from '../../views/dashboard-home';

export const Route = createFileRoute('/dashboard/')({
  component: HomePage,
});
